import { useState } from "react";

import { useIsAdmin } from "@/hooks/useIsAdmin";
import { SCHOOL_TERMS } from "@/lib/schoolYear";

/**
 * Tillfällig jämförelse: datumen som tidigare låg i webbplatsens kod.
 * Visas bara för inloggad administratör och tas bort när API-datumen är godkända.
 */
export function SchoolYearLegacy() {
  const isAdmin = useIsAdmin();
  const [open, setOpen] = useState(false);
  if (!isAdmin) return null;

  return (
    <div className="mx-auto max-w-3xl px-5 pb-16">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="cursor-pointer rounded-md border border-dashed border-border bg-card px-4 py-2 text-sm font-medium text-muted-foreground transition-colors hover:border-primary/40 hover:text-primary"
      >
        {open ? "Dölj våra gamla datum" : "Våra gamla datum (endast admin)"}
      </button>

      {open ? (
        <div className="mt-6 space-y-8">
          {SCHOOL_TERMS.map((term) => (
            <section key={term.id}>
              <h3 className="text-lg font-semibold">{term.term}</h3>
              <dl className="mt-3 divide-y divide-border overflow-hidden rounded-xl border border-dashed border-border bg-card">
                {term.rows.map(([date, text], i) => (
                  <div key={`${date}-${i}`} className="grid gap-1 px-5 py-3 sm:grid-cols-[13rem_1fr]">
                    <dt className="text-sm font-medium text-muted-foreground">{date}</dt>
                    <dd className="text-sm text-foreground/80">{text}</dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </div>
      ) : null}
    </div>
  );
}
